import { Dialog, TextField } from "@mui/material";
import { useState } from "react";
import { defValueTipoDocumento, TTipoDocReceber } from "../../types/api/financeiro/tipos-doc-receber";
import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";

export default function SelectTipoDocReceber({
    value,
    onChange,
    required = false,
    error = false,
    label = "Tipo",
    extraParams = {},
    possuiBtnLimpar = false,
    multiple = false
}: SelectSimpleApiQueryProps) {

    const [openModal, setOpenModal] = useState(false)

    const handleClose = () => setOpenModal(false)

    const inputLabel = (() => {
        if (!value) return "";
        if (Array.isArray(value)) {
            return value.map(item => item.id).join(", ");
        } else {
            return `${value.id ?? ''}${value.nome ? ` - ${value.nome}` : ''}`;
        }
    })();

    return (
        <>
            <TextField
                {...{ required, error, label }}
                variant="outlined"
                fullWidth
                onClick={() => setOpenModal(true)}
                slotProps={{
                    input: { readOnly: true }
                }}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        setOpenModal(true);
                    }
                }}
                value={inputLabel}
                helperText={error ? "Campo obrigatório" : ""}
            />

            {
                openModal &&
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        {...{ extraParams, handleClose, multiple, possuiBtnLimpar }}
                        title="Selecionar tipo de documento"
                        queryPath="/financeiro/contas-receber/pesquisar-tipos-documento"
                        getItemKey={(item) => item.id}
                        getItemLabel={(item) => `${item.id} - ${item.nome}`}
                        defaultValue={
                            multiple
                                ? (Array.isArray(value) && value.length > 0 ? value : [defValueTipoDocumento])
                                : (value ? value : defValueTipoDocumento)
                        }
                        onChange={(value) => {
                            onChange(value as TTipoDocReceber)
                            handleClose()
                        }}
                    />
                </Dialog>

            }
        </>
    )
}

interface SelectSimpleApiQueryProps {
    value: TTipoDocReceber
    onChange: (arg: TTipoDocReceber | null) => void
    required?: boolean
    error?: boolean
    label?: string
    extraParams?: { [key: string]: any };
    possuiBtnLimpar?: boolean
    multiple?: boolean
}